export default __webpack_public_path__ + "static/media/water3.aa4e85a3.png";